import React from 'react';
import { MarketIQLayout } from '../components/MarketIQLayout';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, BarChart2Icon, TrendingUpIcon, DollarSignIcon, InfoIcon, PlayCircleIcon } from 'lucide-react';
export function MarketIQHome() {
  return <MarketIQLayout activeSection={null} data-id="element-449" data-mp="13thhmvijusn3">
      <div className="max-w-4xl mx-auto py-8 mb-16" data-id="element-450" data-mp="13s6gl3ghnyzo">
        {/* Hero Section */}
        <div className="text-center mb-16" data-id="element-451" data-mp="ptghxje0tr97">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-blue-50 text-[#002f5f] rounded-full text-xs font-bold tracking-widest uppercase mb-6" data-id="element-452" data-mp="pvsypt81lvko">
            <BarChart2Icon className="w-4 h-4" data-id="element-453" data-mp="gu398sxq16pj" />
            Market Intelligence
          </div>
          <h1 className="text-5xl md:text-6xl font-['Oswald'] font-bold text-gray-900 uppercase tracking-wide mb-6" data-id="element-454" data-mp="ktvbknwiugmg">
            Real-time USDA Market Data
          </h1>
          <p className="text-xl text-gray-600 font-serif leading-relaxed max-w-3xl mx-auto" data-id="element-455" data-mp="2f8ebcipoi60s">
            Comprehensive pricing, historical trends, and daily analysis for the
            meat and poultry industry.
          </p>
        </div>

        {/* Dashboard Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-456" data-mp="zyuo7rgsvkvc">
          {/* Beef Card */}
          <Link to="/market-iq/beef" className="group block bg-white border border-gray-200 rounded-xl p-8 hover:border-[#002f5f] hover:shadow-md transition-all" data-id="element-457" data-mp="1erwhd700rac9">
            <div className="w-12 h-12 bg-gray-50 rounded-lg flex items-center justify-center mb-6 group-hover:bg-blue-50 transition-colors" data-id="element-458" data-mp="m38tr4rss8vj">
              <TrendingUpIcon className="w-6 h-6 text-gray-700 group-hover:text-[#002f5f]" data-id="element-459" data-mp="vzvdtrcauvwi" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-460" data-mp="qzzggay3y2px">
              Beef Dashboard
            </h3>
            <p className="text-gray-600 text-sm mb-6 h-10" data-id="element-461" data-mp="27d65c8qyogp8">
              Daily boxed beef cutout values, primal cuts, and historical
              spreads.
            </p>
            <div className="border-t border-gray-100 pt-4 flex items-center justify-between" data-id="element-462" data-mp="29j45kwwz2swc">
              <div data-id="element-463" data-mp="2eh5ysao448lj">
                <div className="text-xs text-gray-400 uppercase tracking-wider mb-1" data-id="element-464" data-mp="2egnvwv6y2w4n">
                  Choice Cutout
                </div>
                <div className="font-bold text-gray-900" data-id="element-465" data-mp="2jepbh655wdbd">
                  $3.83{' '}
                  <span className="text-xs font-normal text-gray-500" data-id="element-466" data-mp="2of3l2smevvbi">/lb</span>
                </div>
              </div>
              <ArrowRightIcon className="w-5 h-5 text-gray-400 group-hover:text-[#002f5f] group-hover:translate-x-1 transition-all" data-id="element-467" data-mp="1qqa0qvt2ch5u" />
            </div>
          </Link>

          {/* Pork Card */}
          <Link to="/market-iq/pork" className="group block bg-white border border-gray-200 rounded-xl p-8 hover:border-[#002f5f] hover:shadow-md transition-all" data-id="element-468" data-mp="20og138z81f8l">
            <div className="w-12 h-12 bg-gray-50 rounded-lg flex items-center justify-center mb-6 group-hover:bg-blue-50 transition-colors" data-id="element-469" data-mp="17zsl9sx8ri2f">
              <DollarSignIcon className="w-6 h-6 text-gray-700 group-hover:text-[#002f5f]" data-id="element-470" data-mp="3qb9ep6y8bcct" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-471" data-mp="3mafpma91vric">
              Pork Dashboard
            </h3>
            <p className="text-gray-600 text-sm mb-6 h-10" data-id="element-472" data-mp="3h8qbglqj6xq1">
              Estimated pork carcass cutout and comprehensive primal values.
            </p>
            <div className="border-t border-gray-100 pt-4 flex items-center justify-between" data-id="element-473" data-mp="37bvfoaln7bfg">
              <div data-id="element-474" data-mp="32lneqha18t3r">
                <div className="text-xs text-gray-400 uppercase tracking-wider mb-1" data-id="element-475" data-mp="32l58qsxkj0in">
                  Pork Carcass
                </div>
                <div className="font-bold text-gray-900" data-id="element-476" data-mp="2yk1uubz2zek2">
                  $0.98{' '}
                  <span className="text-xs font-normal text-gray-500" data-id="element-477" data-mp="2tma3pk69fwgx">/lb</span>
                </div>
              </div>
              <ArrowRightIcon className="w-5 h-5 text-gray-400 group-hover:text-[#002f5f] group-hover:translate-x-1 transition-all" data-id="element-478" data-mp="2onqf1c0a86kv" />
            </div>
          </Link>

          {/* Chicken Card */}
          <Link to="/market-iq/chicken" className="group block bg-white border border-gray-200 rounded-xl p-8 hover:border-[#002f5f] hover:shadow-md transition-all" data-id="element-479" data-mp="nlhgrcdq04no">
            <div className="w-12 h-12 bg-gray-50 rounded-lg flex items-center justify-center mb-6 group-hover:bg-blue-50 transition-colors" data-id="element-480" data-mp="drihcl516yzf">
              <BarChart2Icon className="w-6 h-6 text-gray-700 group-hover:text-[#002f5f]" data-id="element-481" data-mp="4sdhnbhqgzlo" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-482" data-mp="9s9mfcy98v2a">
              Chicken Dashboard
            </h3>
            <p className="text-gray-600 text-sm mb-6 h-10" data-id="element-483" data-mp="3r1erpnjphgn2">
              Live chicken reports and whole body trading by size metrics.
            </p>
            <div className="border-t border-gray-100 pt-4 flex items-center justify-between" data-id="element-484" data-mp="1p8qkz47usb2j">
              <div data-id="element-485" data-mp="1u7utrtqv86sc">
                <div className="text-xs text-gray-400 uppercase tracking-wider mb-1" data-id="element-486" data-mp="1u8cy7dnolrbc">
                  Nat'l Composite
                </div>
                <div className="font-bold text-gray-900" data-id="element-487" data-mp="3eqf7zoc9iu6l">
                  $1.29{' '}
                  <span className="text-xs font-normal text-gray-500" data-id="element-488" data-mp="39s3sawzadpgg">/lb</span>
                </div>
              </div>
              <ArrowRightIcon className="w-5 h-5 text-gray-400 group-hover:text-[#002f5f] group-hover:translate-x-1 transition-all" data-id="element-489" data-mp="3oh03h2wn3ila" />
            </div>
          </Link>
        </div>

        {/* Video Tutorial */}
        <div className="mb-16 bg-gray-50 border border-gray-200 rounded-xl overflow-hidden" data-id="element-490" data-mp="1ctxm9xq7mip">
          <div className="aspect-video bg-gray-200 flex items-center justify-center relative group cursor-pointer" data-id="element-491" data-mp="3tguqgvdano12">
            <div className="absolute inset-0 bg-gray-900/5 group-hover:bg-gray-900/10 transition-colors" data-id="element-492" data-mp="6a2fsaivjqjy" />
            <div className="relative flex flex-col items-center gap-3" data-id="element-493" data-mp="2d0a0dsnij6vw">
              <div className="w-16 h-16 rounded-full bg-white/90 shadow-lg flex items-center justify-center group-hover:scale-110 transition-transform" data-id="element-494" data-mp="2d2miq6x6nj9h">
                <PlayCircleIcon className="w-10 h-10 text-[#002f5f]" data-id="element-495" data-mp="bzc6nv280gqv" />
              </div>
              <span className="text-sm font-semibold text-gray-700" data-id="element-496" data-mp="gwlsl0qeia9y">
                Watch: How to Use Market IQ
              </span>
            </div>
          </div>
          <div className="px-8 py-4 flex items-center justify-between" data-id="element-497" data-mp="l1bkyflup6q4">
            <p className="text-sm text-gray-500" data-id="element-498" data-mp="pzd6d76r1i4r">
              A quick walkthrough of dashboards, data sources, and key features.
            </p>
            <span className="text-xs text-gray-400 flex-shrink-0 ml-4" data-id="element-499" data-mp="zvpyi0mnbnxe">
              2:45
            </span>
          </div>
        </div>

        {/* Info Section */}
        <div className="bg-gray-50 border border-gray-200 rounded-xl p-8 flex flex-col md:flex-row gap-8 items-start" data-id="element-500" data-mp="14pc1t26x6fgj">
          <div className="flex-shrink-0 bg-white p-3 rounded-full border border-gray-200 shadow-sm" data-id="element-501" data-mp="1dnwenmpstuwu">
            <InfoIcon className="w-6 h-6 text-[#002f5f]" data-id="element-502" data-mp="1imhevm51wela" />
          </div>
          <div data-id="element-503" data-mp="1ikmqfxukm4cg">
            <h4 className="text-lg font-bold text-gray-900 mb-2" data-id="element-504" data-mp="1sqo3yppnvkic">
              Data Methodology & Sources
            </h4>
            <p className="text-gray-600 text-sm leading-relaxed mb-4" data-id="element-505" data-mp="1nrbh44ysidfr">
              Market IQ aggregates daily and weekly reports from the USDA
              Agricultural Marketing Service (AMS). Our integration with{' '}
              <a href="https://meatmarket.ai/?utm_source=meat_poultry_magazine" target="_blank" rel="noopener noreferrer" className="text-[#002f5f] font-semibold hover:underline" data-id="element-506" data-mp="1es7vat88njxk">
                MeatMarket.ai
              </a>{' '}
              ensures data is normalized, historically accurate, and updated in
              real-time as reports are published.
            </p>
            <a href="https://meatmarket.ai/?utm_source=meat_poultry_magazine" target="_blank" rel="noopener noreferrer" className="text-sm font-semibold text-[#002f5f] hover:underline inline-flex items-center gap-1" data-id="element-507" data-mp="2u7evdu72npqn">
              Visit MeatMarket.ai
              <ArrowRightIcon className="w-3 h-3" data-id="element-508" data-mp="3dvxhm3yo3l9v" />
            </a>
          </div>
        </div>
      </div>
    </MarketIQLayout>;
}